import axios from 'axios';
import EventEmitter from '@/helpers/eventEmitter';

export default class CustomError {
    message: string = 'Unknown Error';
    errorPath: string;
    detail: Error | undefined;
    constructor(error: any, errorPath: string = '') {
        // console.log(error);
        console.log(error);
        if (error instanceof Error) this.message = error.message;
        else if (axios.isAxiosError(error)) this.message = error.message;
        else if (error.message && error.statusCode) this.message = `Error ${error.statusCode} ${error.message}`;
        this.errorPath = errorPath;
    }

    generateMessage(): string {
        return `Error message: ${this.message} 
        path: ${this.errorPath}`;
    }

    /** For non-critical errors */
    notify() {
        const notify = this.generateMessage();
        EventEmitter.trigger('show-noty', {
            type: 'error',
            text: this.message,
        });
        console.log(notify);
    }

    /** For critical errors */
    alert() {
        const alert = this.generateMessage();
        EventEmitter.trigger('show-noty', {
            type: 'error',
            text: this.message,
        });
        console.error(alert);
    }
}
